import React from 'react';
import { Box, SxProps } from '@mui/material';
import KangarooIcon from './KangarooIcon';

type GatewayWhatsappType = 'whaticket' | 'kangaroo' | 'local';

interface GatewayWhatsappTypeIconProps {
  tipo: GatewayWhatsappType;
  size?: number;
  sx?: SxProps;
}

/**
 * Renderiza o ícone correspondente ao tipo de gateway WhatsApp
 */
const GatewayWhatsappTypeIcon: React.FC<GatewayWhatsappTypeIconProps> = ({
  tipo,
  size = 24,
  sx,
}) => {
  if (tipo === 'kangaroo') {
    return <KangarooIcon sx={{ width: size, height: size, ...sx }} />;
  }
  if (tipo === 'local') {
    return (
      <Box
        component="span"
        sx={{ fontSize: size - 4, lineHeight: 1, display: 'inline-flex', alignItems: 'center', ...sx }}
      >
        🔌
      </Box>
    );
  }
  // Whaticket - emoji
  return (
    <Box
      component="span"
      sx={{ fontSize: size, lineHeight: 1, display: 'inline-flex', alignItems: 'center', ...sx }}
    >
      💬
    </Box>
  );
};

export default GatewayWhatsappTypeIcon;
